import { OPEN_PRODUCT_FORM } from '../actionTypes';
import { actions } from '../reducer';

import resetForm from './resetForm';

export default (value) => (dispatch) => {
    if (!value) dispatch(resetForm());
    dispatch(actions[OPEN_PRODUCT_FORM](value));
};
